document.addEventListener('DOMContentLoaded', function(){
    // STICKY HEADER 
    const stickyConfig = {
        sectionHeader: document.querySelector('#shopify-section-header'),
        siteHeader: document.querySelector('header.header'),
        stickyEnabledClass: 'header-wrapper--sticky',
        stickyEnabled: false,
        stickyActive: false,
        stickyInitialized: false,
        forceStopSticky: false,
        stickyClass: 'site-header--stuck',
        stickyClassOpened: 'header-sticky--opened',
        openTransitionClass: 'site-header--opening',
        lastScroll: 0
    };

    // When page is loaded -> Set height of header and set scroll listener
    stickyHeaderHeight()
    
    function stickyHeaderScroll(){
        if (!stickyConfig.siteHeader) return

        const threshold = 230;
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        
        if (currentScroll > threshold) {
            if (stickyConfig.forceStopSticky) {
                return;
            }
        
            stickyConfig.stickyActive = true;
        
            stickyConfig.siteHeader.classList.add(stickyConfig.stickyClass);
            // Add open transition class after element is set to fixed
            // so CSS animation is applied correctly
            setTimeout(function() {
                stickyConfig.siteHeader.classList.add(stickyConfig.openTransitionClass);
            }, 10);

            return
        }

        if (!stickyConfig.stickyActive) {
            return;
        }

        stickyConfig.stickyActive = false;

        stickyConfig.siteHeader.classList.remove(stickyConfig.openTransitionClass)
        stickyConfig.siteHeader.classList.remove(stickyConfig.stickyClass)
    }

    function stickyHeaderHeight() {
        const height = stickyConfig.siteHeader.clientHeight;
        document.querySelector('.site-header--sticky').style.height = `${height}px`;

        window.addEventListener('scroll', stickyHeaderScroll)
    }
})